import { spriteStore } from '../images.js';
import Drawable from '../entities/Drawable.js';
import TypeBadge from './TypeBadge.js';
import PixelText from './PixelText.js';

export default class MoveMenu extends Drawable {
    constructor({
        sprites = { moveOptionsBoxes: spriteStore.store.moveOptionsBoxes },
        textObjects = {},
        position = { x: 0, y: 0 },
        pokemon,
        visible = false,
        resolvedMoves = null, // [Move|null, ...] per slot; when set, overridden slots show in red
    }) {
        super();
        this.sprites = sprites;
        this.textObjects = textObjects;
        this.position = position;
        this.option = 0;
        this.pokemon = pokemon;
        this.visible = visible;
        this.resolvedMoves = resolvedMoves;

        this.textObjects.move0 = new PixelText({
            text: pokemon.moves[0] ? pokemon.moves[0].name : '--',
            color: 'black',
            position: { x: 16, y: 125 },
        });
        this.textObjects.move1 = new PixelText({
            text: pokemon.moves[1] ? pokemon.moves[1].name : '--',
            color: 'black',
            position: { x: 80, y: 125 },
        });
        this.textObjects.move2 = new PixelText({
            text: pokemon.moves[2] ? pokemon.moves[2].name : '--',
            color: 'black',
            position: { x: 16, y: 141 },
        });
        this.textObjects.move3 = new PixelText({
            text: pokemon.moves[3] ? pokemon.moves[3].name : '--',
            color: 'black',
            position: { x: 80, y: 141 },
        });

        this.textObjects.ppLabel = new PixelText({
            text: 'PP',
            color: 'black',
            position: { x: 240 - 72, y: 125 },
        });
        this.textObjects.ppAvailable = new PixelText({
            text: this.pokemon.moves[this.option]
                ? `${this.pokemon.moves[this.option].pp}/${this.pokemon.moves[this.option].maxPP}`
                : '--/--',
            color: 'black',
            textAlign: 'right',
            position: { x: 240 - 8, y: 105 + 20 },
        });
        this.textObjects.typeLabel = new PixelText({
            text: 'TYPE',
            color: 'black',
            position: { x: 240 - 72, y: 105 + 36 },
        });
        this.textObjects.type = new PixelText({
            text: this.pokemon.moves[this.option] ? this.pokemon.moves[this.option].type.toUpperCase() : '--',
            color: 'black',
            textAlign: 'right',
            position: { x: 240 - 8, y: 105 + 36 },
        });
        this.typeBadge = new TypeBadge({
            type: this.pokemon.moves[this.option]
                ? this.pokemon.moves[this.option].type
                : this.pokemon.moves[this.option]['blank'],
            position: { x: 200, y: 160 - 24 },
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.sprites.moveOptionsBoxes.frames.val = this.option;
        this.textObjects.type.text = this.pokemon.moves[this.option]
            ? this.pokemon.moves[this.option].type.toUpperCase()
            : '--';
        this.textObjects.ppAvailable.text = this.pokemon.moves[this.option]
            ? `${this.pokemon.moves[this.option].pp}/${this.pokemon.moves[this.option].maxPP}`
            : '--/--';
        this.sprites.moveOptionsBoxes.draw();

        const moveTexts = [
            this.textObjects.move0,
            this.textObjects.move1,
            this.textObjects.move2,
            this.textObjects.move3,
        ];
        for (let i = 0; i < 4; i++) {
            const resolved = this.resolvedMoves?.[i];
            const actual = this.pokemon.moves[i];
            const displayMove = resolved ?? actual;
            const name = displayMove ? displayMove.name : '--';
            const isOverridden = this.resolvedMoves && resolved && resolved !== actual;
            moveTexts[i].text = name;
            moveTexts[i].setColor(isOverridden ? 'red' : 'black');
            moveTexts[i].draw();
        }

        this.textObjects.ppAvailable.text = `${this.pokemon.moves[this.option]?.pp ?? '--'}/${
            this.pokemon.moves[this.option]?.maxPP ?? '--'
        }`;

        this.textObjects.ppAvailable.draw();
        this.textObjects.typeLabel.draw();
        this.textObjects.ppLabel.draw();
        this.typeBadge.type = this.pokemon.moves[this.option]
            ? this.pokemon.moves[this.option].type
            : 'blank';
        this.typeBadge.draw();
    }
}
